import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

function Label({ project, jobType }) {
  return (
    <div>
      <div className='my4'>
        <strong className='mt3'>Create Label for {project}</strong>
        <p>
          This job requires creating a {jobType} shipping label for {project}.
        </p>
      </div>
      <small className='right-align mt3 light block'>
        Ensure the shipping label is valid before completing this job.
      </small>
    </div>
  )
}

Label.propTypes = {
  project: PropTypes.string.isRequired,
  jobType: PropTypes.string.isRequired
}

function mapStateToProps(state) {
  return {
    project: state.job.details.project_title
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Label)
